import * as React from 'react';
import { useRef, useEffect, useState,useMemo } from 'react';
import Alert from 'react-bootstrap/Alert';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Checkbox from '@mui/material/Checkbox';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import ButtonB from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import HoverComp from "../../components/hoverableImage/HoverableImage"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tooltip from '@mui/material/Tooltip';
import first from "./first.png"
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import axios from 'axios'
import back from "./background.jpg"
import Card from 'react-bootstrap/Card';
import countries from '../information/countryNames.json'    
import AboutUs from '../../components/aboutUs/AboutUs';
import flights from './flights.jpeg'
import { useReactToPrint } from "react-to-print";
import ChatBotComponent from '../../components/chatBot/ChatBotComponent';
import "./home.scss"
const SERVER = `https://volunteer-server.onrender.com`
// const SERVER = `http://localhost:8800`


const steps = ['Оберіть країну', 'Якої допомоги вам надати?' ,'Оберіть тварину','Оберіть вид транспорту','Оберіть дату'];
const resultImages = ['https://zootaxi.bg/wp-content/uploads/2021/06/spetsialn-2i.jpg','https://static01.nyt.com/images/2021/10/22/travel/22airplane-pets/22airplane-pets-superJumbo.jpg','https://di-uploads-pod12.dealerinspire.com/driversautomart/uploads/2017/07/traveling-with-pets-drivers-auto-mart.jpg','https://ochsner-craft.s3.amazonaws.com/blog/articles/_930x524_crop_center-center_75_none/GettyImages-1128207280.jpg','https://www.petcurean.com/app/uploads/2019/11/Volunteering-at-a-Shelter--800x440.jpg']

const Home2 = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // const [tipsData,setTipsData] = useState([])
  // const [rulesData,setRulesData] = useState([])
  // const [advicesData,setAdvicesData] = useState([])
  const [support,setSupport] = useState([])
  const [data,setData] = useState([])
  const [showBtn,setShow] = useState(false)
    const [state, setState] = React.useState({
        cat: true,
        dog: false,
        other: false,
      });
    const [type, setType] = React.useState("");
    const { cat, dog, other } = state;
    const error = [cat, dog, other].filter((v) => v).length !== 2;
    const [help, setHelp] = React.useState({
      petPassport: true,
      rules: false,
      tips: false,
      advices:false,
      explanation:false,
      certificate:false
    });
  const { petPassport, rules, tips,advices,explanation,certificate } = help;
  const errorH = [petPassport, rules, tips,advices,explanation,certificate].filter((v) => v).length !== 2;
  
  const helpUrkainian = {
    petPassport: "Пет паспорт",
    rules: "Умови перевезення",
    tips: "Правила подорожі транспортом",
    advices: "Поради",
    explanation:"Пояснення для заповнення ветеринарного сертифіката",
    certificate:"Зразок ветеринарного сертифікату"
  }  
   

    const titlePasp = "Паспорт домашнього улюбленця - це набір документів (довідки про стан здоров'я, сказ, мікрочіп, дозвіл на ввезення, результати тесту FAVN тощо), які необхідні для в'їзду вашого улюбленця в країну призначення під час міжнародних подорожей. "
    
    const [checked, setChecked] = React.useState(false);
    const [selectValue,setValue] = useState('')
   const [toggled,setToggle] = useState(false)
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
  
    const colors = ["https://givt.com/app/uploads/2020/02/zwierzeta_w_samolocie-k.jpg","https://wwf.ca/wp-content/uploads/2020/05/Volunteers-KR4N-c-Holly-Hewitt-scaled-e1589212502730.jpg", "https://www.hutchinsonanimalservices.com/ImageRepository/Document?documentID=95"];
    const delay = 2500;
    
    function Slideshow() {
      const [index, setIndex] = React.useState(0);
      const timeoutRef = React.useRef(null);
    
      function resetTimeout() {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      }
    
      React.useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(
          () =>
            setIndex((prevIndex) =>
              prevIndex === colors.length - 1 ? 0 : prevIndex + 1
            ),
          delay
        );
    
        return () => {
          resetTimeout();
        };
      }, [index]);
    
      return (
        <div className="slideshow">
          <div
            className="slideshowSlider"
            style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
          >
            {colors.map((backgroundImg, index) => (
              <div
                className="slide"
                key={index}
                style={{  backgroundImage:`url("${backgroundImg}")`,backgroundSize: 'contain',backgroundRepeat: 'no-repeat',backgroundSize: 'cover' }}
              >
                <ButtonB variant="light" size="lg" style={{marginTop:'50%'}} href="#info" onClick={()=>{setToggle(true);setShow(false)}}>ОТРИМАТИ ДОПОМОГУ</ButtonB> 
              </div>
            ))}
            
          </div>
    
          <div className="slideshowDots">
            {colors.map((_, idx) => (
              <div
                key={idx}
                className={`slideshowDot${index === idx ? " active" : ""}`}
                onClick={() => {
                  setIndex(idx);
                }}
              ></div>
            ))}
          </div>
        </div>
      );
    }
 
    useEffect(() => {
      const uniqueArr = Object.values(
        support.reduce((acc, curr) => {
          if (!acc[curr.information]) {
            acc[curr.information] = curr;
          }
          return acc;
        }, {})
      );
      setData(uniqueArr)
    }, [support]);

    const handleChangeHelp = (event) => {
      setHelp({
        ...help,
        [event.target.name]: event.target.checked,
      });
    };
    const handleChangeAnimal = (event) => {
        setState({
          ...state,
          [event.target.name]: event.target.checked,
        });
      };

      const handleChangeType = (event) => {
        setType(
           event.target.value,
        );
      };
    const isStepOptional = (step) => {
      return step === 3;
    };
    const handleChangeInfo = (e) => {
        setValue(e.target.value);
      };
    const isStepSkipped = (step) => {
      return skipped.has(step);
    };
    const handleChange = () => {
        setChecked((prev) => !prev);
      };
    const handleNext = () => {
      setSupport([])
      setData([])
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }
      
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
  
    const handleSkip = () => {
      if (!isStepOptional(activeStep)) {
        // You probably want to guard against something like this,
        // it should never occur unless someone's actively trying to break something.
        throw new Error("You can't skip a step that isn't optional.");
      }
  
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped((prevSkipped) => {
        const newSkipped = new Set(prevSkipped.values());
        newSkipped.add(activeStep);
        return newSkipped;
      });
    };
  
    const handleReset = async() => {
      let cat,dog,other = ""
      let rulesIn,tipsIn,advicesIn,explanationIn,certificateIn = ""
      cat = state.cat && "cat" 
      dog = state.dog && "dog" 
      other = state.other && "other" 
     //let petPassportIn = petPassport && "petPassport"
      rulesIn = rules && "rules"
      tipsIn = tips && "tips"
      advicesIn = advices && "advices"
      explanationIn = explanation && "explanation"
      certificateIn = certificate && "certificate"
     const res = await axios.post(`${SERVER}/api/help/support`,{transport:type,animal:{cat:cat,dog:dog,other:other},help:{rules:rulesIn,tips:tipsIn,advices:advicesIn,explanation:explanationIn,certificate:certificateIn},country:selectValue})
     setSupport(res.data)
      // if(help.tips){
      //    cat = state.cat && "cat" 
      //    dog = state.dog && "dog" 
      //    other = state.other && "other" 
      //   let petPassportIn = petPassport && "petPassport"
      //   let rulesIn = rules && "rules"
      //   let tipsIn = tips && "tips"
      //   const res = await axios.post(`${SERVER}/api/help/tips`,{type,animal:{cat:cat,dog:dog,other:other},help:{petPassport:petPassportIn,rules:rulesIn,tips:tipsIn},country:selectValue})
       
      //   setTipsData(res.data)
      // handleChange()
      // setActiveStep(0);
      // }
      // if(help.rules){
      //   const res = await axios.post(`${SERVER}/api/help/rules`,{type})
        
      //   setRulesData(res.data)
        
      // handleChange()
      // setActiveStep(0);
      // }
      // if(help.advices){
      //   cat = state.cat && "cat" 
      //   dog = state.dog && "dog" 
      //   other = state.other && "other" 
      //   const res = await axios.post(`${SERVER}/api/help/advices`,{animal:{cat:cat,dog:dog,other:other}})
      //   console.log(res.data)
      //   setAdvicesData(res.data)
        
      // handleChange()
      // setActiveStep(0);
      // }

   
      setToggle(false)
      handleChange()
      setShow(true)
      setActiveStep(0);
    };


const datePicker = <div style={{width:'50%',margin:'auto'}}>
     <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={[
          'StaticDatePicker',
        ]}
      >
          <StaticDatePicker defaultValue={dayjs('2022-04-17')} orientation="landscape" />
      
      </DemoContainer>
       </LocalizationProvider>
</div>


const doc = <>
     <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
        <FormLabel component="legend">Якої допомоги вам надати</FormLabel>
        <FormGroup row >
        <Tooltip title={titlePasp} arrow>
          <FormControlLabel
          // style={{backgroundColor: 'blue',width:'100px',height:'100px',borderRadius:'0px'}}
            control={
              <Checkbox checked={petPassport} onChange={handleChangeHelp} name="petPassport" />
            }
            label="Pet Passport"
          />
           </Tooltip>
          <FormControlLabel
            control={
              <Checkbox checked={rules} onChange={handleChangeHelp} name="rules" />
            }
            label="Умови перевезення"
          />
          <FormControlLabel
            control={
              <Checkbox checked={tips} onChange={handleChangeHelp} name="tips" />
            }
            label="Правила подорожі транспортом"
          />
            <FormControlLabel
            control={
              <Checkbox checked={advices} onChange={handleChangeHelp} name="advices" />
            }
            label="Поради"
          />
            <FormControlLabel
            control={
              <Checkbox checked={explanation} onChange={handleChangeHelp} name="explanation" />
            }
            label="Пояснення для заповнення ветеринарного сертифіката"
          />
           <FormControlLabel
            control={
              <Checkbox checked={certificate} onChange={handleChangeHelp} name="certificate" />
            }
            label="Зразок ветеринарного сертифіката"
          />
        </FormGroup>
        
      </FormControl>
      <FormControl
        required
        error={errorH}
        component="fieldset"
        sx={{ m: 3 }}
        variant="standard"
      ></FormControl>
</>



const Info = <>
    <Container style={{marginTop:"1%"}}>
    <label class="form-label" for="description">Оберіть країну</label>
    <Row >
    <Card.Img  src={flights}  style={{width:"70%",margin:"auto",marginTop:'2%',borderRadius:'2%'}}/> 
    </Row>
      <Row style={{width:"90%",marginLeft:"16%"}}>
        <Col xs={5}>
            <InputGroup className="mb-3" style={{width:'80%'}}>
            
                <Form.Control
                 value={selectValue} 
                placeholder="Введіть країну"
                aria-label="Username"
                aria-describedby="basic-addon1"
                onChange={handleChangeInfo} 
                />
            </InputGroup>
        </Col>
        <Col xs={4}>
            <Form.Select aria-label="Default select example"
             value={selectValue} 
             onChange={handleChangeInfo} 
            >
                <option>Оберіть країну</option>
               
                { countries.map((el)=>(
            <option value={el}>{el}</option> 
                )
                      
                )}
            </Form.Select>
        </Col>
       
      </Row>
      
    </Container>
</>
    
    const PickAnimal = <>
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
        <FormLabel component="legend">Оберіть тварину з якою подорожуєте</FormLabel>
        <FormGroup row>
          <FormControlLabel
          style={{fontWeight: 600,backgroundImage:`url("https://cdn.pixabay.com/photo/2014/11/30/14/11/cat-551554__340.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'white',paddingBottom:'5%'}}
            control={
              <Checkbox checked={cat} onChange={handleChangeAnimal} name="cat" />
            }
            label="Кіт"
          />
          <FormControlLabel
          style={{fontWeight: '600',backgroundImage:`url("https://paradepets.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTkxMzY1Nzg4NjczMzIwNTQ2/cutest-dog-breeds-jpg.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'black',paddingBottom:'5%'}}
          
            control={
              <Checkbox checked={dog} onChange={handleChangeAnimal} name="dog" />
            }
            label="Собака"
          />
          <FormControlLabel
          style={{fontWeight: '600',backgroundImage:`url("https://oir.mobi/uploads/posts/2021-05/1620319299_11-oir_mobi-p-popugai-i-khomyak-zhivotnie-krasivo-foto-11.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'black',paddingBottom:'5%'}}
          
            control={
              <Checkbox checked={other} onChange={handleChangeAnimal} name="other" />
            }
            label="Інші"
          />
        </FormGroup>
        
      </FormControl>
      <FormControl
        required
        error={error}
        component="fieldset"
        sx={{ m: 3 }}
        variant="standard"
      ></FormControl>
    </>

const PickType = <>
            <FormControl>
      <FormLabel id="demo-radio-buttons-group-label" style={{marginBottom:'1%'}}>Оберіть транспорт</FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        row
      
      >
        <FormControlLabel value={'train'} control={<Radio />} label="Потягом" onChange={handleChangeType}  
        style={{backgroundImage:`url("https://static.euronews.com/articles/stories/07/38/48/50/1440x810_cmsv2_75c4ef08-8979-5087-aa7f-6165a018f42f-7384850.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'black',paddingTop:'15%',fontWeight: '900'}}
        />
        <FormControlLabel value={'plane'} control={<Radio />} label="Літаком" onChange={handleChangeType}
       style={{backgroundImage:`url("https://cdn.britannica.com/69/155469-131-14083F59/airplane-flight.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'black',paddingTop:'15%'}}
       />
        <FormControlLabel value={'car'} control={<Radio />} label="Машиною" onChange={handleChangeType}
        style={{backgroundImage:`url("https://i.pinimg.com/originals/bf/73/b1/bf73b18845346e612c1741a085fbdc46.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'white',paddingTop:'15%'}}
        />
        <FormControlLabel value={'all'} control={<Radio />} label="Не знаю" onChange={handleChangeType}
       style={{backgroundImage:`url("https://www.shutterstock.com/image-vector/vector-not-understanding-man-icon-260nw-358493978.jpg")`,width:'200px',height:'200px',borderRadius:'5%',backgroundSize: 'cover',color:'white',paddingTop:'12%'}}
        />
      </RadioGroup>
    </FormControl>
    </>

  return (
    <div style={{textAlign:"center"}} >
 
      <Container md >
      <Row style={{height:'90vh',marginTop:'2%',borderRadius: '50%'}}>
      <Slideshow />
      </Row>
     <Row style={{marginTop:'2%'}}>
        <Col>
        <img src={first} style={{borderRadius:'2%',width:'100%'}}/>
        </Col>
        <Col style={{margin:'auto'}} className='container-form1'>
            <div  style={{textAlign:"left"}}>
    
            Подорож з домашнім улюбленцем може бути непростим завданням, особливо при пересуванні незнайомою територією.
         На щастя, існують системи допомоги, які допоможуть українським власникам домашніх тварин безпечно та комфортно подорожувати зі своїми пухнастими друзями.
Одне з найважливіших питань, яке слід враховувати під час подорожі з домашнім улюбленцем - це транспортування.
 Багато авіакомпаній та поїздів мають суворі правила щодо перевезення домашніх тварин, тому важливо вивчити ці правила заздалегідь, щоб забезпечити безпроблемну подорож.
 Деякі авіакомпанії та залізничні компанії також пропонують житло та зручності, пристосовані для тварин, наприклад, спеціально відведені зони для тварин, тому варто вивчити ці варіанти.
            </div>
      
 <Button variant="outlined" style={{marginTop:'2%'}} href="#info" onClick={()=>{setToggle(true);setShow(false)}}>ОТРИМАТИ ДОПОМОГУ</Button>

        </Col>
     </Row>

     <Row style={{marginTop:'2%'}}>
     <Col style={{margin:'auto'}} className='container-form2'>
     <div  style={{textAlign:"left"}}>
     Реалії сьогодення з якими стикнулась Україна та українське суспільство сприяли згуртуванню населення та фахівців різноманітних сфер.
             Майже мільйон людей уже рятуються від війни в Україні, а разом з ними і багато улюблених домашніх тварин. 
             Щоб забезпечити ввезення численних тварин до Європи, сусідні країни та деякі інші держави вже адаптували свої правила.
             «Волонтер» з французької означає «доброволець», тобто «волонтерство» – суспільно важлива, безкорислива, добровільна діяльність.
              Принципом такої діяльності є те, що особистість діє за покликом душі, через потребу реалізувати свою громадську позицію. 
              Саме це сприяє формуванню суспільної свідомості. 
            </div>
      
 <Button variant="outlined" style={{marginTop:'2%'}} href="#info" onClick={()=>{setToggle(true);setShow(false)}}>ОТРИМАТИ ДОПОМОГУ</Button>
        </Col>
        <Col>
        <img src={back} style={{borderRadius:'2%',width:'100%'}}/>
        </Col>
      
     </Row>
     <AboutUs/>
        <h3 style={{fontSize: '38px',lineHeight: '1.23',color: 'black',fontFamily: '`Roboto`,Arial,sans-serif',fontWeight: '600',color: '#000'}}>ДОДАТКОВІ ПОСИЛАННЯ</h3>
    <Row style={{marginTop:'2%'}}>
      <Col>
      <Link to="/search" relative="path" style={ {textDecoration: 'none',color:'black',textAlign:"center"} }>
<HoverComp  text={"Пошук волонтерських організацій або ветеринарних клінік"} img={"https://images.fineartamerica.com/images/artworkimages/mediumlarge/1/our-beautiful-watercolor-world-map-irina-sztukowski.jpg"}/>
</Link>
      </Col>
      <Col>
      <Link to="/forum" relative="path" style={ {textDecoration: 'none',color:'black',textAlign:"center"} }>
<HoverComp  text={"Задавайте питання на форумі"} img={"https://static5.depositphotos.com/1006899/400/i/600/depositphotos_4000740-stock-photo-forum.jpg"} />
</Link>
      
      </Col>
      <Col>
      
      <Link to="/information" relative="path" style={ {textDecoration: 'none',color:'black',textAlign:"center"} }>
        <HoverComp text={"Шукати інформацію про конкретну країну"} img={"https://www.travelnuity.com/wp-content/uploads/2018/12/Pet-Passports.jpg"}/>
        </Link>
      </Col>
    </Row>


   {toggled ? 
     <Row id='info'>
     <Box sx={{ width: '100%' }} style={{marginTop:'2%'}} >
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Отримати інформацію</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div style={{height:'400px'}}>
          
            {activeStep==0 ? Info : null}
            {activeStep==1 ? doc : null}
            {activeStep == 2 ? PickAnimal : null}
            {activeStep == 3 ? PickType : null}
            {activeStep == 4 ? datePicker : null}
            </div>
          {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: '1 1 auto' }} />
            {isStepOptional(activeStep) && (
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            )}

            <Button onClick={handleNext}>
              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
            </Button>
          </Box>
        </React.Fragment>
      )}
    </Box>

     </Row>
: null}
      
      {showBtn ? <Button variant="outlined" style={{marginTop:'2%',marginBottom:'2%'}} onClick={handlePrint}>Роздрукувати</Button> : null}
    {/* <Paper elevation={3} style={{padding:'2%'}}> */}
      <Row ref={componentRef}>
    
      <Col>
      {/* {data ? data.map((el)=>(
              <ol>
              
               {el.information.split(/\d+\. /).map((l)=>(
                              <Alert key="primary" variant="primary">
                             {l}
                            </Alert>
                             
                             ))}
              
              </ol>
               
              )) : null} */}
                {data ? data.map((el,ind)=>(
                  

                        <Card style={{width:'90%',marginLeft:'auto',marginRight:'auto',marginBottom:'2%'}}>
                            <Card.Img variant="top" src={el.img ? require(`./${el.img}`) : resultImages[ind]} />
                            <Card.Body>
                              <Card.Title>{helpUrkainian[el.helpType]}</Card.Title>
                              <Card.Text style={{textAlign:'left'}}>
                              <Alert key="primary" variant="primary">
                              
                                {el.information}
                                  
                                  </Alert>
                              </Card.Text>
                              <ButtonB variant="primary" href={el.link}>Посилання на джерело</ButtonB>
                            </Card.Body>
                          </Card>
                             
                             
                        
              
             
               
              )) : null}
      </Col>
      {/* <Col>
      {rulesData ? rulesData.map((el)=>(
                              <>
                                 {el.information.split(/[.:]/).map((l)=>(
                                  <Alert key="primary" variant="primary">
                                 {l}
                                </Alert>
                                 
                                 ))}
                              </>
                             
                            )) : null}
      </Col> */}
            

     
     </Row>
     {/* </Paper>   */}

    </Container>
   
      
    </div>
  )
}

export default Home2